import { Stack, Alert } from "@mui/material"
import { Link } from "react-router-dom"
import Tip from "../Tools/Tip"
import { txt } from "../../services/translation"

export default function NotFound(){

    return <div className='social-box'>
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{mb: 2}}>
            <b>{txt('notFound')}</b>
            <Link to='/community/feed'>
                <Tip type='close'/>
            </Link>
        </Stack>
        <Alert severity='warning'>{txt('postDeleted')}</Alert>
    </div>
    
}

